import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';

@Injectable({
  providedIn: 'root'
})
export class PlatformToolGmtCountryAnalysisHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;

  destroy(): void {
    this.invalidateSubject.close();
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
  }

  magicLinkModelValueChangedHandler(payload: any) {
    this.magicLinkModelValueChanged.emit(payload);
  }
}
